import {ActivatedRoute} from '@angular/router';
import {Component, Input, OnInit} from '@angular/core';
import {filter, switchMap} from "rxjs/operators";

@Component({
  selector: 'app-page-head',
  templateUrl: './page-head.component.html',
  styleUrls: ['./page-head.component.scss']
})
export class PageHeadComponent implements OnInit {

  @Input() title: string;
  heading: string;

  paths: any = [
    {url: '', heading: 'Meus projetos', icon: ''},
    {url: 'historical', heading: 'Histórico de modificações', icon: ''},
    {url: 'reminders', heading: 'Lembretes', icon: ''},
    {url: 'planning', heading: 'Planejamento', icon: ''},
  ];

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {

    if (!this.title) {
      this.route.url.pipe(
        filter((val: any) => Number.isInteger(val.path)),
        switchMap((val: any) => val.path)
      ).subscribe((url) => {
        console.log(url)
      });
    } else {
      this.heading = this.title;
    }

  }

}
